import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// easing effect transition
const transition = {
  duration: 0.6,
  ease: [0.43, 0.13, 0.23, 0.96],
};
const Header = () => {
  return (
    <div className="header">
      <motion.div className="header_inner">
        <Link to="/contact" style={{ textDecoration: 'none' }}>
          <motion.div
            whileHover={{ scale: 1.1 }}
            transition={transition}
            className="contact"
          >
            <motion.div>
              <p>Contact Me</p>
            </motion.div>
          </motion.div>
        </Link>
      </motion.div>
    </div>
  );
};

export default Header;
